import Vue from 'vue';
import store from './../../store';
import getlistentries from './getlistentries';

const PUTLISTENTRY_URL = '/api/v1/lists/';

// When the request succeeds
const successPutListEntry = () => {
  // console.log(response);
  // store.dispatch('getURLLookup', response.data);
  // console.log(response);
  // Vue.router.push({
  //   name: 'home.index',
  // });
  // return lookupResponse.data;
  getlistentries(store.state.lists.listentries_list_id,
    store.state.lists.listentries_pageinfo.thispage_number,
    store.state.lists.listentries_pageinfo.pagesize,
    0);
};

// When the request fails
const failedPutListEntry = () => {
};

export default (entryobj) => {
  const axiosOptions = {
    timeout: 30000,
    headers: { 'X-Auth-Token': localStorage.getItem('jwt') },
    maxRedirects: 0,
    withCredentials: false,
  };
  // const queryinfo = {
  //   urls: listarray,
  // };
  // console.log(lines);
  const listid = entryobj.list_id;
  const entryid = entryobj.url_id;
  const thisurl = `${PUTLISTENTRY_URL}${listid}/entries/${entryid}`;

  Vue.$http.put(thisurl, entryobj, axiosOptions)
   .then((response) => {
     successPutListEntry(response);
   })
   .catch((error) => {
     failedPutListEntry(error);
   });
};



// WEBPACK FOOTER //
// ./src/app/services/list/editlistentry.js